"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.network = void 0;
const core_common_1 = require("./core-common");
const logging_1 = require("./logging");
$(function () {
    (0, logging_1.logScriptLoad)("[core] [network]");
});
exports.network = {
    fetchData: async function fetchData(url) {
        (0, logging_1.log)("Entering method.", 3 /* LogType.Information */, "fetchData");
        (0, core_common_1.clearAndHideInfoBar)();
        try {
            (0, logging_1.log)(`Calling url: ${url}`, 3 /* LogType.Information */, "fetchData");
            const response = await fetch(url);
            if ((response === null || response === void 0 ? void 0 : response.status) === 500) {
                const body = await response.json().catch(() => null);
                if ((body === null || body === void 0 ? void 0 : body.code) === "ExternalServiceFailure" || (body === null || body === void 0 ? void 0 : body.code) === "InternalApiError") {
                    (0, logging_1.log)(`Upstream failure calling '${url}', showing callback request form.`, 1 /* LogType.Error */, "fetchData");
                    (0, core_common_1.showRetailerInfoDialog)();
                    return { success: false, count: 0, view: "" };
                }
            }
            if (!response || !response.ok) {
                throw new Error(`Network error calling ${url}: ${response.statusText}`);
            }
            const json = await response.json();
            return json;
        }
        catch (err) {
            (0, logging_1.log)(`Error calling '${url}': ${err.message}`, 1 /* LogType.Error */, "fetchData");
            throw err;
        }
        finally {
            (0, logging_1.log)("Leaving method.", 3 /* LogType.Information */, "fetchData");
        }
    }
};
